import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import VisaApplicationTableContainer from '../containers/visa-application-table.container';
import VisaApplicationDetailsContainer from '../containers/visa-application-details.container';
import VisaApplicationCreateContainer from '../containers/visa-application-create.container';
import VisaApplicationUpdateContainer from '../containers/visa-application-update.container';
import {
  DEFAULT_PAGINATION_LIMIT,
  DEFAULT_PAGINATION_PAGE,
} from '../../../../../const/default-paginated-table-data.const';
import TenantGuard from '@components/common/TenantGuard';

// Helper function to add default query parameters to the visa application list page
const VisaApplicationListWithParams = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  // Set default params if they don't exist
  if (!params.has('page')) {
    params.set('page', DEFAULT_PAGINATION_PAGE.toString());
  }
  if (!params.has('limit')) {
    params.set('limit', DEFAULT_PAGINATION_LIMIT.toString());
  }

  // If query params need to be added
  if (location.search !== `?${params.toString()}`) {
    return <Navigate to={`?${params.toString()}`} replace />;
  }

  return <VisaApplicationTableContainer />;
};

export const visaApplicationRoutes = [
  {
    path: 'visa-application',
    element: (
      <TenantGuard showHeader={true} headerTitle="Visa Application List" showBreadcrumbs={true}>
        <VisaApplicationListWithParams />
      </TenantGuard>
    ),
  },
  {
    path: 'visa-application/create',
    element: (
      <TenantGuard showHeader={true} headerTitle="Create Visa Application" showBreadcrumbs={true}>
        <VisaApplicationCreateContainer />
      </TenantGuard>
    ),
  },
  {
    path: 'visa-application/:id',
    element: (
      <TenantGuard showHeader={true} headerTitle="Visa Application Details" showBreadcrumbs={true}>
        <VisaApplicationDetailsContainer />
      </TenantGuard>
    ),
  },
  {
    path: 'visa-application/:id/update',
    element: (
      <TenantGuard showHeader={true} headerTitle="Update Visa Application" showBreadcrumbs={true}>
        <VisaApplicationUpdateContainer />
      </TenantGuard>
    ),
  },
];

export default visaApplicationRoutes;


